import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ScreenshotCMP from 'components/screenshot/Screenshot';
import { b64ToBlob } from 'utils';
import { UiButton, UiIcon, UiTextField } from 'ui-components';
import { useDispatch } from 'react-redux';
import { addTicketRequest } from 'store';
import { toast } from 'lib';

const FeedbackModalForm = ({ handleStep, toggleHamburger }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [imageSrc, setImageSrc] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);

  /* دریافت تصویر بعد از گرفتن اسکرین شات */
  const handleChangeImage = (src) => {
    setImageSrc(src);
  };

  /**
   * ارسال فیدبک
   */
  const handleSubmit = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append('title', 'bug');
    formData.append('category_id', 1);
    formData.append('description', description);
    if (imageSrc) {
      formData.append('attachments[0]', b64ToBlob(imageSrc));
    }

    try {
      await dispatch(addTicketRequest({ formData: formData })).unwrap();
      setDescription('');
      handleStep('step_3');
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast({
        title: t('support:error.addTicket.title'),
        description: t('support:error.addTicket.description'),
        type: 'error',
      });
    }
  };

  return (
    <>
      <div className='feedback-component-header step-header'>
        <div className='header-info'>
          <UiIcon
            className='mr-0'
            icon='ri-arrow-right-s-line'
            size={20}
            color='#454545'
            onClick={() => handleStep('step_1')}
          />
          <span className='label'>{t('support:pageTitle')}</span>
        </div>
        <UiIcon
          className='header-close'
          icon='ri-close-circle-fill'
          size={20}
          color='#9CAEBB'
          onClick={toggleHamburger}
        />
      </div>
      <div className='feedback-component-body'>
        <div className='body-support mt-8'>
          <div>{t('support:explainDetailsOfYourProblem')}</div>

          <ScreenshotCMP
            toggleHamburger={toggleHamburger}
            onChange={handleChangeImage}
          />

          <div className='mt-16'>{t('common:description')}</div>
          <div className='button--wrapper flex col'>
            <UiTextField
              className='mb-16 textbox'
              rows={3}
              multiline
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
            <UiButton
              variant='contained'
              color='primary'
              fullWidth
              onClick={handleSubmit}
              disabled={loading || !description}
              loading={loading}
            >
              {t('support:send')}
            </UiButton>
          </div>
        </div>
      </div>
    </>
  );
};

FeedbackModalForm.propTypes = {
  handleStep: PropTypes.func,
  toggleHamburger: PropTypes.func,
};

export default FeedbackModalForm;
